import {Component, NgZone, OnInit} from '@angular/core';
import {RestrictionsService} from "./restrictions.service";
import {PointOfSaleA2Service} from "../../core/point-of-sale.service.service";
import {ActivatedRoute} from '@angular/router';
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import * as _ from "lodash";
import {DateService} from "../../core/date.service";
import {SidebarService} from "../../root/sidebar/sidebar.service";
import {ContractService} from "../../core/contract.service";
import {EvaMessage} from "../../shared/eva-message/eva-message";
import {NotificationService} from "../../root/toast/notification.service";

@Component({
    selector: 'restrictions',
    providers: [RestrictionsService, PointOfSaleA2Service, DateService],
    templateUrl: './restrictions.component.html'
})

export class RestrictionsComponent implements OnInit{
    pointsOfSale = [];
    companyOid: number;
    specialValues : any;

    defaultRestrictions;
    restrictions = [];

    constructor(private route:ActivatedRoute,
                private loading: LoadingWheelService,
                private posService: PointOfSaleA2Service,
                private restrictionsService: RestrictionsService,
                private dateService: DateService,
                private sidebar: SidebarService,
                private contractService: ContractService,
                private ngZone: NgZone,
                private toast:NotificationService) {
        this.message = new EvaMessage('restrictions.ERROR.noBranchesAssociated', '', '-warning', 'warning');
        this.sidebar.sidebar = "generalSettings";
    }
    result = false;
    hasActiveContract = false;
    totalPos = [];
    message:EvaMessage;
    showMessage = false;

    ngOnInit(){
        this.loading.show();
        this.route.params.subscribe(params => {
            this.companyOid = params["id"];
            this.ngZone.run(() => {
                var fieldsPos = {
                    'fields': "name,oid"
                };

                this.restrictionsService.getDefaultRestrictions(this.companyOid).subscribe(response => {
                    this.defaultRestrictions = response;
                });

                //TODO fix llamadas anidadas
                this.contractService.get(this.companyOid).subscribe(contracts => {
                    let activePosOidList =  [];
                    if(!!contracts){
                        for (let contract of contracts) {
                            if(!!contract.pointsOfSale && contract.pointsOfSale.length > 0){
                                for (let posOid of contract.pointsOfSale){
                                    activePosOidList.push(posOid);
                                    this.hasActiveContract = true;
                                }
                            }
                        }
                        if (this.hasActiveContract) {
                            this.restrictionsService.getRestrictions(this.companyOid).subscribe(response => {
                                this.restrictions = this.processDates(response);
                                this.loading.show();
                                this.posService.getWithOptionalParams(this.companyOid, fieldsPos).subscribe(pointsOfSale => {
                                    this.loading.show();
                                    this.totalPos = pointsOfSale.filter(pos => activePosOidList.includes(pos.oid));
                                    this.result = true;
                                    this.setPosName(this.totalPos);
                                    this.processRestrictions();
                                    this.loading.hide();
                                });
                            });
                        }else{
                            this.result = true;
                            //show message
                            this.showMessage = true;
                            this.loading.hide();
                        }
                    }
                });
            });
        });
    }

    processDates(values){
        for (let item of values){
            if(item.validity){
                item.period = {
                    from: this.dateService.formatStringToDate(item.validity.from),
                    to: this.dateService.formatStringToDate(item.validity.to)
                };
                item.validity.from = this.dateService.formatString(item.validity.from);
                item.validity.to = this.dateService.formatString(item.validity.to);
                item.validity.always = false;
            }else{
                item['validity'] = {'always': true};
                /*check duplicated*/
                item.period = {
                    from: null,
                    to: null
                }
            }
            item.status = 'edit';
        }
        return values;
    }

    setPosName(pos){
        for (var i in this.restrictions){
            for (var n in pos){
                if (this.restrictions[i].pointOfSaleOid == pos[n].oid){
                    this.restrictions[i].name = pos[n].name;
                }
            }
        }
    }

    processRestrictions(){
        this.restrictions = _.sortBy(this.restrictions, [function(o) { return [o.name, !o.validity.always] }]);
    }

    removeSpecialSetting(restriction){
        let context = this;
        this.restrictionsService.deleteSpecialSetting(this.companyOid, restriction.oid, restriction.pointOfSaleOid).subscribe(response => {
            this.removeCallback();
        });
    }

    private removeCallback(){
        this.toast.displayToast('restrictions.TITLE','common.confirmationMessage.SUCCESS_DELETE', null, 'INFO');
        this.ngOnInit();
    }

    updateGeneralSetting(restriction){
        this.loading.show();
        this.ngOnInit();
        //TODO pass POST to booking component
    }

    savePosRestriction(restriction){
        this.loading.show();
        this.ngOnInit();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/restrictions.component.ts